import CardBody from '../../../src/components/card/CardBody';
import {useDispatch, useSelector} from "react-redux";
import EmptyState from "../../components/EmptyState";
import React, {useEffect, useState} from "react";
import {
  loadBundleTimers,
  reset,
  setVisibility,
  tryUpdateBundleTimerItem
} from "../../redux/slices/dynamicElementsSlice";
import LoadingState from "../../components/LoadingState";
import {ComponentError} from "../../components/ComponentLoader";
import CustomIcon from "../../components/CustomIcon";
import CustomButton, {DangerButton} from "../../components/CustomButton";
import BundleTimerSelector from "./components/BundleTimerSelector";
import CustomDeleteModal from "../../components/CustomDeleteModal";
import PlatformToggle from "../../components/PlatformToggle";
import {MemoizedFocusedItemsProductView} from "../dynamicUi/elements/focused/FocusedItemsProductView";

const BundleTimerUi = () => {
  const dispatch = useDispatch();
  const {
    loading, error, init, data
  } = useSelector((state) => state.dynamicElements.bundleTimers);


  useEffect(() => {
    if (!init && !error && !loading) {
      dispatch(loadBundleTimers());
    }

  }, [init, error, loading]);

  useEffect(() => {

    return () => {
      dispatch(reset({element: 'bundleTimers'}));
    };

  }, []);


  const removeTimer = (selectedItem) => {
    if (selectedItem?.id)
      dispatch(tryUpdateBundleTimerItem({id: selectedItem.id, add: false}));
  };

  return (
    <>
      <CardBody>

        <div className="flex space-x-2 mb-2 justify-end">
          {!!data.length &&
            <DangerButton onClick={() => dispatch(setVisibility({visible: true, type: "delete"}))} isIconButton={true}
                          disabled={loading || !init || error}>
              <CustomIcon icon="delete"/>
            </DangerButton>
          }
          <CustomButton onClick={() => dispatch(setVisibility({visible: true, type: "edit"}))} isIconButton={true}
                        disabled={(loading || !init) && !error}>
            <CustomIcon icon={data.length ? 'edit' : 'add'}/>
          </CustomButton>
        </div>


        {error ? <ComponentError errorMsg={error} retry={() => dispatch(loadBundleTimers())}/> : loading || !init ?
          <LoadingState/> : data.length ? <BundleUiBody data={data}/> :
            <EmptyState title="Please add it from above." message="Timers not added"/>}


      </CardBody>
      <BundleTimerSelector
        selected={data.length ? data[0] : undefined}/>
      <CustomDeleteModal onDelete={removeTimer} selected={data.length ? data[0] : undefined}/>
    </>
  );
};


const BundleUiBody = ({data = []}) => {
  const [mobileView, setMobileView] = useState(true);

  return (
    <div className="flex justify-center">
      <div className="flex flex-col items-center">
        <PlatformToggle mobileView={mobileView} mobileOnClick={() => setMobileView(true)}
                        webOnClick={() => setMobileView(false)}/>

        <div className={`${mobileView ? 'mobile' : 'web'} ${mobileView ? 'max-w-md' : 'max-w-6xl'}`}>
          {data.map((d) => <MemoizedFocusedItemsProductView key={d.id} mobile={mobileView}
            // endDate={d.flash_sale ? '2023-10-04T22:25:00' : ''}
                                                            focused={{init: true, data: d}}
                                                            type={d?.type}/>)}
        </div>
      </div>
    </div>
  );
};


export default BundleTimerUi;